import { APP_URL, getEnvironment } from "../constants/app-url"

/**
 * App code mappings for URL transformation
 */
export const APP_CODE_MAPPINGS: Record<string, string> = {
  iam: "idm",
  ins: "insights",
  rbigw: "rbi"
} as const

/**
 * Transforms FormIO API URL from .io to .com format with proper app code mapping
 * @param apiBaseUrl - The base API URL to transform
 * @returns Transformed URL or original URL if invalid
 */
export const formIOAPIUrl = (apiBaseUrl: string, tenant: string): string => {
  try {
    const url = new URL(apiBaseUrl)
    const appCode = url.pathname.slice(1)
    const mappedAppCode = APP_CODE_MAPPINGS[appCode] || appCode
    const environment = getEnvironment()
    const urlAppCode = mappedAppCode ? `.${mappedAppCode}` : ""
    const envPart = environment === "prod" ? "" : `.${environment}`
    const urlDomain = `${envPart}.forcepointone.com`

    return `${url.protocol}//${tenant}${urlAppCode}${urlDomain}`
  } catch (error) {
    console.error("Error transforming FormIO API URL:", error)
    return apiBaseUrl
  }
}

/**
 * Replace tenant function.
 * @param prefix - URL prefix template with {tenantHost} placeholder
 * @param tenant - Tenant identifier to replace in the URL
 * @param domain - Optional domain to replace
 * @returns Processed URL with tenant replacement
 */
export function replaceTenant(
  prefix: string,
  tenant: string,
  domain?: string
): string {
  if (prefix === "") {
    return ""
  }
  const appUrl = new URL(APP_URL)
  const { protocol, hostname } = appUrl
  let urlWithTenantHost = prefix?.replace("{tenantHost}", tenant)

  if (!urlWithTenantHost) {
    return protocol + "//" + hostname
  }

  // URL Prefixes with STATIC: should not be transformed to .io/.com. Directly use the provided URL
  if(urlWithTenantHost.startsWith("STATIC:")){
    urlWithTenantHost = urlWithTenantHost.replace("STATIC:", "")
    return urlWithTenantHost
  }

  if (hostname.includes(".forcepointone.") && urlWithTenantHost.includes(".io")) {
    return formIOAPIUrl(urlWithTenantHost, tenant)
  }

  if (!urlWithTenantHost.includes(".com") && !urlWithTenantHost.includes(".io")) {
    return urlWithTenantHost.replace(
      "." + domain,
      hostname.includes("forcepointone") ? ".com" : ".io"
    )
  }
  return urlWithTenantHost
}
